import { ObserverService, ContentService, LessonService, PortfolioService } from "@DavisDigital/davisdigitalfrontend.module";
import { FolderTypes, AccessAccount} from "@DavisDigital/interfaces";

export type ExportModalType = 'portfolio' | 'folder' | 'lesson';

class ExportContentModalController {
    
    private close:Function; //injected from modal-service
    
    public title: string;
    public baseObjectId: string;
    public type: ExportModalType;
    public folderType:  string;
    public systemCode:  FolderTypes;
    public displayType:string = "Lesson";
    
    
    public contentList = [];
    public selectedContent:string = "";
    public downloadType:string = "";
    public successMessage: string;
    public isSaveSuccess = false;
    public errors:any = [];
    public isLoading:boolean = false;
	public emailAddress:string;
	public validateEmail:boolean = false;
	public selectAllContent:string = "";
	public showEmailAddress:boolean = false;
	
	// @ngInject
	constructor(
		public $timeout         : ng.ITimeoutService,
		public contentService   : ContentService,
		public lessonService   : LessonService,
		public portfolioService   : PortfolioService,
		public observerService  : ObserverService,
		public  $rootScope      : ng.IRootScopeService,
	){}
	
	public $onInit = () => {
        if(this.type=="portfolio") {
        	this.displayType = "Portfolio";
        	this.getPortfolioList();
        } else {
        	this.getLessonList();
        }
        
        //get current account to check for primary email address
        let account = this.$rootScope.slatwall.getAccount().then(result=>{
        	if(!result?.primaryEmailAddress || result?.primaryEmailAddress?.accountEmailAddressID == "") {
        		this.validateEmail = true;
        	}
        });
	}
	
	public onCloseModal = () =>{
		this.close();
	}
	
	public exportContent = (downloadType) => {
		
		//return if isLoading is already true (it means another call is in process)
		if(this.isLoading){
			return;
		}
		
		//download now flag
		let downloadNow:boolean = false;
		//check selected count
		let selectedCount:number = this.contentList.filter(item => item.checked === true ).length;
		//set download now flag to true if only one item selected
		if( selectedCount == 1 ) {
			downloadNow = true;
		}
		
		//set download type to manipulate button view on submit
		this.downloadType = downloadType;
		
		this.errors = [];
		//regex check to validation email on frotnend
		const regexCheck = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		
		if(this.validateEmail && this.showEmailAddress) {
			if( this.emailAddress == ""){
				this.errors.push("URL is required");
				return;
			} else if(!regexCheck.test(this.emailAddress)) {
				this.errors.push("Invalid email address");
				return;
			}
		}
		
		//Get All Selected Lessons
		let selectedIds = [];
		this.contentList.forEach( (key, value) => {
            if (key.checked) {
            	selectedIds.push( this.type=="lesson" ? key.lessonID : key.portfolioID  );
            }
		});
		this.selectedContent = selectedIds.join(",");
		
		if( this.selectedContent != "") {
			this.isLoading = true;
			
			let downloadLink:string = "";
			if(this.type=="lesson") {
				
				if( downloadNow ) {
					downloadLink = '?slatAction=davisdigital:api.exportLessons&apiData.lessonID=' + this.selectedContent + '&apiData.downloadNowFlag=true';
				} else {
					this.contentService.exportLessons(this.selectedContent, downloadType, false, this.emailAddress, this.baseObjectId).then(this.handleExportCallback);
				}
				
			} else if(this.type=="portfolio") {
				if( downloadNow ) {
					downloadLink = '?slatAction=davisdigital:api.exportPortfolios&apiData.portfolioID=' + this.selectedContent + '&apiData.downloadNowFlag=true';
				} else {
					this.contentService.exportPortfolios(this.selectedContent, downloadType, false, this.emailAddress, this.baseObjectId).then(this.handleExportCallback);
				}
			}
			
			if( downloadNow ) {
				var anchor = document.createElement('a');
		        anchor.href = downloadLink;
		        anchor.target = '_blank';
		        document.body.appendChild(anchor);
		        anchor.click();
		        document.body.removeChild(anchor);
		        
		        this.isLoading = false;
		        this.isSaveSuccess = true;
				this.successMessage = 'A new window or pop up will open with download link.';
			}
			
		} else {
			this.errors.push("You have not selected anything.");
		}
	}
	
	private handleExportCallback = (result) => {
		this.isLoading = false;
		if(result.data.successfulActions.length){
			this.isSaveSuccess = true;
			this.successMessage = 'You will receive an email shortly with download link.';
			//this.close();
		}
		//TODO: handle error and success message
	}
	
	private getLessonList = () => {
		var data = {"folderID": this.baseObjectId};
		// Q: why not use getMyLessons with folderId as filter?
		this.lessonService.getFolderLessons(data).then(result => {
			this.contentList = result.records;
			for ( let i = 0; i < this.contentList.length; i++ ) { 
				this.contentList[ i ].checked = false;
			}
		});
	}
	
	private getPortfolioList = () => {
		var data = {
			"folder": {"folderID": this.baseObjectId} ,
			'showAll': true,
		};
		if(this.systemCode === FolderTypes.MySharedWithMePortfolio || this.systemCode === FolderTypes.MyStudentsPortfolio){
				this.portfolioService.getFolderItems(data).then(result => {
			this.contentList = result.data.records;
			for ( let i = 0; i < this.contentList.length; i++ ) { 
				this.contentList[ i ].checked = false;
			}
		});
		}else if(this.folderType === 'sharedPortfolios' ){
			this.portfolioService.getSharedPortfolios(data).then(result => {
				this.contentList = result.data.records;
				for ( let i = 0; i < this.contentList.length; i++ ) { 
					this.contentList[ i ].checked = false;
				}
			});
		}else{
			this.portfolioService.getMyPortfolios(data).then(result => {
				this.contentList = result.data.records;
				for ( let i = 0; i < this.contentList.length; i++ ) { 
					this.contentList[ i ].checked = false;
				}
			});
		}
	
	}
	
	/**
	 * Method to handle select All feature
	 * */
	public selectAll = () => {
		for ( let i = 0; i < this.contentList.length; i++ ) { 
			this.contentList[ i ].checked = this.selectAllContent == '1';
			this.showEmailAddress = this.selectAllContent == '1' && this.validateEmail;
		}
	}
	
	/**
	 * Method to set showEmailAddress flag to true if there are more than one selected lessons / portfolios and 
	 * and user account doesn't have primary email address
	 * */
	public checkSelectedItems = () => {
		let checkSelected = this.contentList.filter(item => item.checked === true ).length;
		this.showEmailAddress = checkSelected > 1 && this.validateEmail;
	}

}
    

class ExportContentModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
		folderType: "<?",
		systemCode: "<?",
	    title: "<",
	    baseObjectId: "<",
	    type: "<",
		close:'='
	};

	public controller = ExportContentModalController;
	public controllerAs = 'exportContentModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/export-content-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ExportContentModal };
